<template>
  <div class="ads-negative-key">
    <div class="header-box">
      <el-button
        type="primary"
        size="small"
        id="addNewKey"
        @click="dialogAddNewVisible = true"
        >新增否定关键词</el-button
      >
    </div>
    <el-table :data="tableData" border size="mini" style="width: 300px" cell-class-name="table-cell"
      row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column type="index" label="序号" align="center"> </el-table-column>
      <el-table-column prop="matchTypeText" label="匹配类型"> </el-table-column>
      <el-table-column prop="content" label="否定关键词"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click.native.prevent="onDeleteClick(scope, tableData)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="新增否定关键字"
      :visible.sync="dialogAddNewVisible"
      @close="onDialogAddNewClose"
      width="26%"
    >
      <el-form :model="addNewForm">
        <el-form-item label="匹配类型" :label-width="formLabelWidth">
          <el-radio-group v-model="addNewForm.negativeType">
            <el-radio :label="4">否定词精准查询</el-radio>
            <el-radio :label="5">否定词短语查询</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="否定关键词" :label-width="formLabelWidth">
          <el-input
            v-model="addNewForm.negativeKey"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onDialogAddNewClose">取 消</el-button>
        <el-button type="primary" @click="onDialogAddNewConfirm('addNewForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adsModules } from "@r";
export default {
  data() {
    return {
      tableData: [],
      dialogAddNewVisible: false,
      addNewForm: {
        negativeKey: "",
        negativeType: 4
      },
      formLabelWidth: "120px",
      requestType: null,
      campaignsId: null,
      groupId: null,
      addStatus: false
    };
  },
  created() {},
  activated() {
    this.campaignsId = this.$route.query.campaignsId - 0;
    this.groupId = this.$route.query.groupId - 0;
    this.requestType = this.$route.query.type;
    this.country = this.$route.query.country || "";
    this.queryAdsList();
  },
  methods: {
    queryAdsList() {
      // 根据广告组还是广告活动请求不同接口
      adsModules
        .getNegativeKeywordList({
          requestType: this.$route.query.type,
          params: {
            beginIndex: this.beginIndex,
            pageSize: this.pageSize,
            campaignId: this.campaignsId,
            groupId: this.groupId
          }
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "列表请求出错"
            });
            return;
          }
          this.tableData = res.ldata;
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err.message ? err.message : "列表请求出错"
          });
        });
    },
    onDeleteClick(scope, rows) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          adsModules
            .deleteNegativeKeywords({
              requestType: this.requestType,
              keywordId: scope.row.id,
              country: this.country
            })
            .then(res => {
              if (res.result !== 1) {
                this.$message({
                  type: "error",
                  message: res.message ? res.message : "删除出错"
                });
                return;
              }
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              rows.splice(scope.$index, 1);
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message ? err.message : "删除出错"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    onDialogAddNewClose() {
      this.addNewForm = {
        negativeKey: "",
        negativeType: 4
      };
      this.dialogAddNewVisible = false;
    },
    onDialogAddNewConfirm(data) {
      if(this.addStatus == true){
        return;
      }
      this.addStatus = true;
      adsModules
        .insertNegativeKeywords({
          requestType: this.requestType,
          campaignId: this.campaignsId,
          groupId: this.groupId,
          matchType: this.addNewForm.negativeType,
          keywordText: this.addNewForm.negativeKey
        })
        .then(res => {
          this.addStatus = false;
          this.$message({
            type: "success",
            message: "新增成功!"
          });
          this.queryAdsList();
        })
        .catch(err => {
          this.addStatus = false;
          this.$message({
            type: "error",
            message: err.message ? err.message : "未知错误!"
          });
        });
      this.dialogAddNewVisible = false;
    }
  }
};
</script>

<style lang="scss">
.ads-negative-key {
  .header-box {
    text-align: left;
    padding-left: 0px;
    #addNewKey {
      width: auto;
    }
  }
  .el-input {
    width: 300px;
  }
}
</style>
